var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWithdrawMobileSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.980469,
    y: 0.395508,
    width: 42.2277,
    height: 42.2277,
    rx: 21.1139,
    fill: "#50AD20"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4414 17.9888V13.2969L32.6523 21.5078L24.4414 29.7188V24.9095C18.5764 24.9095 14.471 26.7863 11.5385 30.8918C12.7115 25.0268 16.2304 19.1618 24.4414 17.9888Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawMobileSvg);
export default __webpack_public_path__ + "static/media/withdrawMobileSvg.e11356e0b188f9f82f4198dd9a03927b.svg";
export { ForwardRef as ReactComponent };